'use client'

import { Button, Image } from '@vinted/web-ui'

import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { useAsset } from '@marketplace-web/shared/assets'
import { clickEvent } from '@marketplace-web/marketing-campaigns/marketing-landing-page-data'
import { ClickableElement } from 'constants/tracking/clickable-elements'
import { Screen } from 'constants/tracking/screens'

import { CHECK_STATUS_URL } from '../../constants'

type Props = { ukVersion?: boolean }

const CheckStatusSection = ({ ukVersion }: Props) => {
  const translate = useTranslate('dac7-2024.check_status')
  const { track } = useTracking()
  const asset = useAsset('/assets/landing-pages/dac7')

  const imageSrc = asset(`Illustration-6-${ukVersion ? 'UK' : 'EU'}-version.png`)
  const imageSrc2x = asset(`Illustration-6-${ukVersion ? 'UK' : 'EU'}-version@2x.png`)
  const imageSrc3x = asset(`Illustration-6-${ukVersion ? 'UK' : 'EU'}-version@3x.png`)
  const imageSrcSet = `${imageSrc} 1x, ${imageSrc2x} 2x, ${imageSrc3x} 3x`

  const handleOnCtaClick = () => {
    track(
      clickEvent({
        screen: Screen.Dac7,
        target: ClickableElement.CtaRedirect,
        targetDetails: `checkstatus_section__${CHECK_STATUS_URL}`,
      }),
    )
  }

  const renderImage = () => (
    <Image src={imageSrc} srcset={imageSrcSet} scaling={Image.Scaling.Cover} loading="lazy" />
  )

  return (
    <section className="dac7__checkstatus" data-testid="checkstatus-section">
      <div className="dac7__checkstatus-inner">
        <div>
          <h2 className="dac7__checkstatus-title">{translate('title')}</h2>
          <div className="dac7__checkstatus-cta">
            <Button
              styling={Button.Styling.Filled}
              text={<span className="dac7__checkstatus-cta-text">{translate('cta')}</span>}
              url={CHECK_STATUS_URL}
              onClick={handleOnCtaClick}
              testId="checkstatus-cta"
              inverse
            />
          </div>
        </div>
        <div className="dac7__checkstatus-image">{renderImage()}</div>
      </div>
    </section>
  )
}

export default CheckStatusSection
